<template>
  <modal
    :show="isVisible"
    :title="titulo"
    elem-id="modal_cliente_combo_correcao"
    size="small"
    :close-label="t('Voltar')"
    :save-label="isSaving ? t('Salvando') : t('Confirmar')"
    :save-fn="handleSave"
    @close="handleClose"
    @dismiss="handleClose"
  >
    <template v-if="isVisible && dados">
      <cliente-combo-correcao-form
        ref="formRef"
        :acao="dados.acao"
        :purchase-id="dados.purchaseId"
        :combo-nome="dados.comboNome"
        :movimento-id="dados.movimentoId"
        @submit-success="handleFormSuccess"
      />
    </template>
  </modal>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import ClienteComboCorrecaoForm from './ClienteComboCorrecaoForm.vue';

interface OpenPayload {
  acao: 'estornar' | 'ajustar' | 'cancelar';
  purchaseId: number;
  comboNome: string;
  movimentoId?: number;
}

const { t } = useI18n();

const isVisible = ref<boolean>(false);
const isSaving = ref<boolean>(false);
const dados = ref<OpenPayload | null>(null);
const formRef = ref<{ handleSubmit: () => Promise<void> } | null>(null);

const titulo = computed<string>(() => {
  if (dados.value?.acao === 'estornar') return t('Estornar consumo');
  if (dados.value?.acao === 'cancelar') return t('Cancelar compra do combo');
  return t('Ajustar saldo do combo');
});

const handleClose = (): void => {
  isVisible.value = false;
  isSaving.value = false;
  dados.value = null;
};

const handleSave = async (): Promise<void> => {
  isSaving.value = true;
  try {
    await formRef.value?.handleSubmit();
  } finally {
    isSaving.value = false;
  }
};

const handleFormSuccess = (): void => {
  eventBus.emit('cliente-combos.refresh');
  handleClose();
};

const handleModalOpen = (data?: OpenPayload): void => {
  if (!data) return;
  dados.value = data;
  isVisible.value = true;
};

onMounted(() => {
  eventBus.on<OpenPayload>('modal.cliente-combo-correcao.open', handleModalOpen);
});

onBeforeUnmount(() => {
  eventBus.off<OpenPayload>('modal.cliente-combo-correcao.open', handleModalOpen);
});
</script>
